/**
 * @flow
 * @relayHash 727703263d5b819de0fa595a521e3164
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type infoBarContainer_GetInfobar_QueryVariables = {||};
export type infoBarContainer_GetInfobar_QueryResponse = {|
  +user: ?{|
    +id: string,
    +isAdmin: boolean,
    +person: {|
      +email: string,
      +id: string,
      +profilePicture: ?string,
      +firstname: ?string,
      +lastname: ?string,
    |},
  |}
|};
export type infoBarContainer_GetInfobar_Query = {|
  variables: infoBarContainer_GetInfobar_QueryVariables,
  response: infoBarContainer_GetInfobar_QueryResponse,
|};
*/


/*
query infoBarContainer_GetInfobar_Query {
  user {
    id
    isAdmin
    person {
      email
      id
      profilePicture
      firstname
      lastname
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "user",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      v0,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isAdmin",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "person",
        "storageKey": null,
        "args": null,
        "concreteType": "Person",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          v0,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "profilePicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstname",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastname",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "infoBarContainer_GetInfobar_Query",
  "id": null,
  "text": "query infoBarContainer_GetInfobar_Query {\n  user {\n    id\n    isAdmin\n    person {\n      email\n      id\n      profilePicture\n      firstname\n      lastname\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "infoBarContainer_GetInfobar_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "infoBarContainer_GetInfobar_Query",
    "argumentDefinitions": [],
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec81ad6e2a13d1c4beffcfd54a7b613b';
module.exports = node;
